import { CompanyDocumentType } from '@/enterprise/data/useUploadCompanyDocument';
import { EnterpriseTrackEventNames } from '@/reporting/trackEventNames';
import { ReportAttributes } from '@/reporting/types';

export const INSTANT_PAY_ONBOARDING_EVENT = 'instant-pay::onboarding' satisfies EnterpriseTrackEventNames;

export type InstantPayOnboardingEvent =
  | { step: 1; action: 'started' }
  | { step: 1; action: 'document-started' | 'document-completed'; documentType: CompanyDocumentType }
  | { step: 2; action: 'started' | 'completed' }
  | {
      step: 3;
      action: 'downloaded' | 'uploaded';
      makerOrganizationUuid: string;
      envelopeUuid: string;
    };

type TrackEnterpriseEvent = (event: EnterpriseTrackEventNames, attributes?: ReportAttributes) => void;

export function trackInstantPayOnboarding(
  trackEnterpriseEvent: TrackEnterpriseEvent,
  event: InstantPayOnboardingEvent
): void {
  trackEnterpriseEvent(INSTANT_PAY_ONBOARDING_EVENT, event);
}
